import DataSetChart from '@components/dataTables/Charts/DataSetChart';
import DefaultScreen from '@components/Global/DefaultScreenView';
import { Button } from 'tamagui';
import { Table, TableBody, TableCell, TableHead, TableRow, Dialog, DialogActions, DialogTitle, List, ListItem } from '@mui/material';
import ProductList from '@navigation/screens/TopLevel/StoreScreen/Components/ProductList';
import styles from '@stylesheet';
import { toInteger } from 'lodash';
import moment from 'moment';
import React, { useState } from 'react';
import { View, Text } from 'react-native';
import { TextArea } from 'tamagui';

export interface SimpleDialogProps {
  open: boolean;
  selectedValue: any;
  onClose: (value: any[]) => void;
}

function SimpleDialog(props: SimpleDialogProps) {
  const { onClose, selectedValue, open } = props;
  const [productName, setProductName] = useState('');
  const [productPrice, setProductPrice] = useState('');

  const handleClose = () => {
    onClose(selectedValue);
  };

  const handleListItemClick = (value: any[]) => {
    onClose(value);
  };

  return (
    <Dialog onClose={handleClose} open={open}>
      <DialogTitle>Add a product</DialogTitle>
      <View style={{ flexDirection: "row" }}>
        <TextArea label="Product Name" />
        <TextArea label="Price" />
      </View>
      <Button onClick={() => {
        selectedValue.push({ name: productName, price: productPrice });
        handleListItemClick(selectedValue);
      }}>Add</Button>
      <ProductList />
    </Dialog>
  );
}

const Forecast = () => {
  const [monthForecast, setMonthForecast] = useState([
    {
      month: 'January',
      forecast: 0
    },
    {
      month: 'February',
      forecast: 0
    },
    {
      month: 'March',
      forecast: 0
    },
    {
      month: 'April',
      forecast: 0
    },
    {
      month: 'May',
      forecast: 0
    },
    {
      month: 'June',
      forecast: 0
    },
    {
      month: 'July',
      forecast: 0
    },
    {
      month: 'August',
      forecast: 0
    },
    {
      month: 'September',
      forecast: 0
    },
    {
      month: 'October',
      forecast: 0,
    },
    {
      month: 'November',
      forecast: 0,
    },
    {
      month: 'December',
      forecast: 0,
    },
  ]);
  const [productList, setProductList] = useState([]);
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = (value: any[]) => {
    setOpen(false);
    setProductList(value);
  };

  return (
    <DefaultScreen containerStyle={{ flex: 1 }} scrollDisabled style={{ flex: 1 }} searchBar={{
      searchParams: {
        placeholder: "Search for a forecast",
        searchType: "forecast"
      }
    }}>
      <View style={{ flex: 1, gap: 30, paddingVertical: 20, paddingBottom: 50, flexGrow: 1, flexDirection: "row" }}>
        <View style={{ flex: 6, gap: 20 }}>
          <DataSetChart
            minHeight={300}
            chart={{
              options: {
                xaxis: {
                  labels: {
                    format: 'MMM',
                  }
                }
              },
              //Get timestamp from month
              labels: monthForecast.map((month) => moment(month.month, 'MMMM').format('MMM' + ' YYYY')),
              series: [
                {
                  name: 'Team A',
                  type: 'column',
                  fill: 'solid',
                  data: monthForecast.map((month) => month.forecast),
                },
              ],
            }}
          />
          <View style={[styles.defaultCardContainer, { flex: 3, justifyContent: "center", alignContent: "center", alignItems: "center" }]}>
            {
              productList.length > 0 ?
                <Table key={productList.length}>
                  <TableHead>
                    <TableCell>
                      <Text>Product</Text>
                    </TableCell>
                    {
                      monthForecast.map((month, index) => (
                        <TableCell key={index}>
                          <Text>{moment(month.month, "MMMM").format("MMM")}</Text>
                        </TableCell>
                      ))
                    }
                  </TableHead>
                  {
                    productList.map((product, index) => (
                      <TableRow key={index}>
                        <TableCell>
                          <Text>{product.name}</Text>
                        </TableCell>
                        {
                          monthForecast.map((month, index) => {
                            const [value, setValue] = useState(month.forecast);
                            return (
                              <TableCell key={index}>
                                <TextArea value={value} inputMode='numeric' onChangeText={(text) => setValue(toInteger(text))} />
                              </TableCell>
                            )
                          })
                        }
                      </TableRow>
                    ))
                  }
                </Table>
                :
                <Text style={styles.paragraphText}>Select or add products to start forecasting</Text>
            }
          </View>
        </View>
        <View style={[styles.defaultCardContainer, { flex: 1, minWidth: 400 }]}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell style={{ flex: 4 }}>
                  <Text>Product</Text>
                </TableCell>
                <TableCell style={{ flex: 1 }}>
                  <Text>Price</Text>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {productList.length > 0 ?
                productList.map((product, index) => (
                  <TableRow key={index}>
                    <TableCell style={{ flex: 4 }}>
                      <Text>{product.name}</Text>
                    </TableCell>
                    <TableCell style={{ flex: 1 }}>
                      <TextArea value={product.price} onChangeText={
                        (text) => {
                          const newProductList = [...productList];
                          newProductList[index].price = text;
                          setProductList(newProductList);
                        }
                      } />
                    </TableCell>
                  </TableRow>
                ))
                :
                <TableRow>
                  <TableCell>
                    <Text style={{ textAlign: "center" }}>No products added yet</Text>
                  </TableCell>
                </TableRow>
              }
            </TableBody>
          </Table>
          <Button onClick={() => {
            handleClickOpen();
          }}>Add Product</Button>
          <SimpleDialog selectedValue={productList} open={open} onClose={handleClose} />
        </View>
      </View>
    </DefaultScreen>
  );
};
export default Forecast;